import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function initDividerAnimation() {
  const dividers = document.querySelectorAll('.animate-divider')

  dividers.forEach(divider => {
    ScrollTrigger.create({
      trigger: divider,
      start: 'top center',
      end: 'bottom center',
      once: true,
      onEnter: () => {
        gsap.to(divider, { width: '100%', duration: 1 })
      }
    })
  })
}
